import { Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Meta, Title } from '@angular/platform-browser';
import { Dialog } from "app/common/dialog";
import { NGXLogger } from "ngx-logger";
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { IPriority, Priority } from 'app/models/priority';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'app-base',
    templateUrl: './base.component.html',
    styleUrls: ['./base.component.scss'],
    standalone: false
})
export class BaseComponent implements OnDestroy {
  @BlockUI() blockUI: NgBlockUI;

  public alreadyRequesting: boolean = false;

  public pageTitle: string = '';
  public subscriptions: Array<Subscription> = [];
  public priorities: IPriority[];
  
  public sizeXL = '&size=800';
  public sizeLarge = '&size=400';
  public sizeSmall = '&size=56';
  public sizeMedium = '&size=200';
  
  public isRecoveringData: boolean = false;
  
  constructor(public translateService: TranslateService, 
    public title: Title, 
    protected dialog: Dialog,
    public logger: NGXLogger) {
    // Section header
    this.updateContentHeader();
    this.translateService.onLangChange.subscribe(() => {
      this.updateContentHeader();
    });
  }

  public getString(value: string, params?): string {
    let str = '';
    this.translateService.get(value, params).subscribe((res: string) => {
      return (str = res);
    });
    return str;
  }

  fullPageBlockUI() {
    this.blockUI.start(); // Start blocking
  }

  odd(num: number){
    return num%2;
  }

  pair(num: number){
    return !(num%2);
  }

  showMessageDelete() {
    return this.dialog.showAsk(this.getString('GENERAL.DELETE'), '');
  }

  showImageDetail(img, override?, defaultSrc?) {
    return this.dialog.showImage(img, override, defaultSrc);
  }

  setTitle(){
    this.title.setTitle(this.pageTitle);
  }


  fullPageStopBlockUi(){
    this.blockUI.stop(); // Stop blocking
  }

  toMonthName(monthNumber: number): string {
    const date = new Date();
    date.setMonth(monthNumber - 1);

    switch (this.translateService.currentLang) {
      case 'es':
        return date.toLocaleString('es-ES', {
          month: 'long',
        });
        break;
      case 'ca':
        return date.toLocaleString('ca', {
          month: 'long',
        });
        break;
      case 'fr':
        return date.toLocaleString('fr-FR', {
          month: 'long',
        });
        break;
      case 'en':
        return date.toLocaleString('en-US', {
          month: 'long',
        });
        break;

      default:
        return date.toLocaleString('en-US', {
          month: 'long',
        });
        break;
    }
  }

  dateToNgbDate(date: Date): NgbDate{
    return new NgbDate(date.getFullYear(), date.getMonth(), date.getDate());
  }

  ngbDateToDate(date: NgbDate): Date{
    return new Date(date.year, date.month - 1, date.day);
  }

  dateToRequest(date:Date) : string {    
    if(date === undefined)
      return ''
    let day = String(date.getDate().toString()).padStart(2,'0')
    return `${date.getFullYear()}-${date.getMonth()+1}-${day}`;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }
  
  getPriority(): any {
    this.priorities = [
      {
        name: this.getString('GENERAL.PRIORITY_LOW'),
        value: Priority.Low,
      },
      {
        name: this.getString('GENERAL.PRIORITY_MEDIUM'),
        value: Priority.Medium,
      },
      {
        name: this.getString('GENERAL.PRIORITY_HIGH'),
        value: Priority.High,
      },
      {
        name: this.getString('GENERAL.BLOCKING'),
        value: Priority.Blocking,
      },
    ];
  }

  protected updateContentHeader(): void {}
}
